// slider.js
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';

export function initSinglePieceSlider() {
  const sliderContainer = document.querySelector('.single-piece-slider');
  if (!sliderContainer) return;

  let swiperInstance = null;
  let isSwiperInitialized = false;
  let paginationEl = null;

  function enableSwiper() {
    if (isSwiperInitialized) return;

    // Add swiper classes
    sliderContainer.classList.add('swiper');
    const wrapper = document.createElement('div');
    wrapper.classList.add('swiper-wrapper');

    // Move children into wrapper
    const slides = Array.from(sliderContainer.children);
    slides.forEach(slide => {
      slide.classList.add('swiper-slide');
      wrapper.appendChild(slide);
    });
    sliderContainer.appendChild(wrapper);

    // Add pagination element
    paginationEl = document.createElement('div');
    paginationEl.classList.add('swiper-pagination');
    sliderContainer.appendChild(paginationEl);

    // Initialize Swiper
    swiperInstance = new Swiper(sliderContainer, {
      modules: [Pagination],
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: false,
      loop: false,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        375: { slidesPerView: 1 },
        567: { slidesPerView: 2 },
      },
    });

    isSwiperInitialized = true;
  }

  function disableSwiper() {
    if (!isSwiperInitialized) return;

    swiperInstance.destroy(true, true);
    isSwiperInitialized = false;

    // Restore original structure
    const wrapper = sliderContainer.querySelector('.swiper-wrapper');
    if (wrapper) {
      const slides = Array.from(wrapper.children);
      slides.forEach(slide => {
        slide.classList.remove('swiper-slide');
        sliderContainer.appendChild(slide);
      });
      wrapper.remove();
    }

    // Remove pagination
    if (paginationEl) {
      paginationEl.remove();
      paginationEl = null;
    }

    sliderContainer.classList.remove('swiper');
  }

  function checkViewport() {
    if (window.innerWidth < 768) {
      enableSwiper();
    } else {
      disableSwiper();
    }
  }

  checkViewport();
  window.addEventListener('resize', checkViewport);
}
